import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_ADMINISTRATE].GET_MY_WORKS_TO_ADMINISTRATE]:{
    url:'/company/:companyId/done_works/my_works/to_administrate/'
  }
}